(function () {
  const selectors = {
    card: '[data-product-card]',
    reservedCard: '[data-product-card-reserve-swatch-slot]',
    cardText: '.card__text.product-item__text',
    image: '.itg_card_promainimg img',
    titleLink: '[data-product-card-link="title"]',
    imageLink: '[data-product-card-link="image"]',
    titleText: '[data-product-card-title-text]',
    title: '.product-item__title',
    priceRow: '[data-product-card-price]',
    priceContent: '.itg_price_ctmmmm',
    rating: '[data-oke-star-rating]',
    quickAddLink: '[data-product-card-quick-buy] .quick-add-to-cart a',
    linkedVariant: '[data-product-card-linked-variant]',
    linkedVariantPrice: '.itg_meta_price_hide .product-price--original',
    variantInput: '[data-product-card-variant-input]',
  };

  const layout = {
    rowTopTolerance: 4,
  };

  let equalizeFrame = 0;
  let equalizeTimeout = 0;

  // Liquid can't resolve product_option_value.variant for a Combined Listings
  // value that belongs to a linked child product (see product-item.liquid), so
  // the static markup for those swatches is only a same-product placeholder.
  // Fetch the linked product's own data, same as the PDP variant picker does
  // via product_option_value.product_url (component-product-form.js
  // debounceOptionLoad), and cache it since a card can be revisited.
  const fetchedProductData = new Map();

  function fetchProductJson(url) {
    const key = url.split('?')[0];

    if (!fetchedProductData.has(key)) {
      fetchedProductData.set(
        key,
        fetch(`${key}.js`)
          .then(function (response) {
            if (!response.ok) throw new Error(`Failed to fetch ${key}.js`);
            return response.json();
          })
          .catch(function (error) {
            fetchedProductData.delete(key);
            throw error;
          })
      );
    }

    return fetchedProductData.get(key);
  }

  function formatPrice(cents) {
    if (window.KROWN && typeof window.KROWN.utils?.formatMoney === 'function') {
      return window.KROWN.utils.formatMoney(cents);
    }

    return `$${(cents / 100).toFixed(2)}`;
  }

  function findMatchingVariant(productData, optionValue) {
    const byOption = productData.variants.find(function (variant) {
      return variant.options && variant.options.includes(optionValue);
    });

    return byOption || productData.variants.find(function (variant) { return variant.available; })
      || productData.variants[0];
  }

  function applyFetchedProductData(card, input, productData) {
    const variant = findMatchingVariant(productData, input.value);
    if (!variant) return;

    const image = variant.featured_image?.src || productData.featured_image?.src || productData.images?.[0];
    if (image) {
      updateCardImage(card, `${image}${image.includes('?') ? '&' : '?'}width=600`);
    }

    updateQuickAddLink(card, null, productData.id);

    const priceEl = card.querySelector(selectors.priceContent);
    if (!priceEl) return;

    const hiddenSpan = priceEl.querySelector('.visually-hidden');
    const fromText = getFromPriceText(priceEl, formatPrice(variant.price));
    priceEl.innerHTML = (hiddenSpan ? `${hiddenSpan.outerHTML} ` : '') + fromText;
    scheduleCardLayoutRefresh(getCardLayoutContainer(card));
  }

  function refreshSwatchFromLinkedProduct(card, input, url) {
    fetchProductJson(url)
      .then(function (productData) {
        // The user may have picked a different swatch (or a different card's
        // fetch resolved late) by the time this comes back — only apply it if
        // this input is still the one that's actually selected.
        if (input.checked && getCard(input) === card) {
          applyFetchedProductData(card, input, productData);
        }
      })
      .catch(function () {
        // Keep the optimistic same-product placeholder already rendered.
      });
  }

  function getCard(node) {
    return node ? node.closest(selectors.card) : null;
  }

  function getFromPriceText(priceEl, price) {
    const priceHtml = `<span class="product-price__value">${price}</span>`;
    if (!priceEl.hasAttribute('data-from-price')) return priceHtml;

    const template = priceEl.getAttribute('data-from-template');
    if (template) {
      return template.split('[price]').join(priceHtml);
    }

    return priceHtml;
  }

  function syncCardData(card, data) {
    if (!card || !data) return;

    const attributes = {
      'data-product-id': data.productId,
      'data-product-handle': data.productHandle,
      'data-product-url': data.productUrl,
      'data-product-title': data.productTitle,
      'data-variant-id': data.variantId,
    };

    Object.entries(attributes).forEach(function ([name, value]) {
      if (value) {
        card.setAttribute(name, value);
      }
    });
  }

  function updateCardImage(card, imageUrl) {
    if (!imageUrl) return;

    const mainImg = card.querySelector(selectors.image);
    if (!mainImg) return;

    mainImg.src = imageUrl;
    mainImg.srcset = imageUrl;
  }

  function updateCardLinks(card, href) {
    if (!href) return;

    const titleLink = card.querySelector(selectors.titleLink);
    const imageLink = card.querySelector(selectors.imageLink);

    if (titleLink) titleLink.href = href;
    if (imageLink) imageLink.href = href;
  }

  function updateCardTitle(card, title) {
    if (!title) return;

    const titleText = card.querySelector(selectors.titleText);
    if (titleText) {
      titleText.textContent = title;
    }
  }

  function updateQuickAddLink(card, href, productId) {
    const quickAddLink = card.querySelector(selectors.quickAddLink);
    if (!quickAddLink) return;

    if (productId) {
      quickAddLink.setAttribute('data-pro_id', productId);
      quickAddLink.setAttribute('data-id', productId);
    }

    if (href) {
      quickAddLink.setAttribute('href', href);
    }
  }

  function updatePriceFromLinkedVariant(card, variant) {
    const priceMarkup = variant.querySelector(selectors.linkedVariantPrice);
    const targetPrice = card.querySelector(selectors.priceContent);

    if (priceMarkup && targetPrice) {
      targetPrice.innerHTML = priceMarkup.innerHTML;
    }
  }

  function setActiveLinkedVariant(card, activeVariant) {
    card.querySelectorAll(selectors.linkedVariant).forEach(function (variant) {
      variant.classList.toggle('active', variant === activeVariant);
    });
  }

  function updateCardFromLinkedVariant(variant) {
    const card = getCard(variant);
    if (!card) return;

    const layoutContainer = getCardLayoutContainer(card);

    syncCardData(card, {
      productId: variant.getAttribute('data-product-id') || variant.getAttribute('data-pro_id'),
      productHandle: variant.getAttribute('data-product-handle'),
      productUrl: variant.getAttribute('data-product-url') || variant.getAttribute('data-href'),
      productTitle: variant.getAttribute('data-title'),
      variantId: variant.getAttribute('data-variant-id'),
    });

    updateCardImage(card, variant.getAttribute('data-metaimage'));
    updateCardTitle(card, variant.getAttribute('data-title'));
    updatePriceFromLinkedVariant(card, variant);
    updateCardLinks(card, variant.getAttribute('data-href'));
    updateQuickAddLink(card, variant.getAttribute('data-href'), variant.getAttribute('data-pro_id'));
    setActiveLinkedVariant(card, variant);
    scheduleCardLayoutRefresh(layoutContainer);
  }

  function updateCardFromVariantInput(card, input, forceUpdate) {
    if (!input) return;

    const layoutContainer = getCardLayoutContainer(card);
    const productId = input.getAttribute('data-product-id') || card.getAttribute('data-product-id');
    const productUrl = input.getAttribute('data-product-url') || card.getAttribute('data-product-url');

    syncCardData(card, {
      productId,
      productHandle: input.getAttribute('data-product-handle') || card.getAttribute('data-product-handle'),
      productUrl,
      productTitle: card.getAttribute('data-product-title'),
      variantId: input.getAttribute('data-variant-id') || card.getAttribute('data-variant-id'),
    });

    updateCardImage(card, input.getAttribute('data-variant-image'));
    updateCardLinks(card, productUrl);
    updateQuickAddLink(card, productUrl, productId);

    const needsFetchUrl = input.getAttribute('data-swatch-needs-fetch');
    if (needsFetchUrl) {
      refreshSwatchFromLinkedProduct(card, input, needsFetchUrl);
    }

    const price = input.getAttribute('data-variant-price');
    const priceEl = card.querySelector(selectors.priceContent);

    if (!price || !priceEl) return;

    const currentPriceValue = priceEl.querySelector('.product-price__value');
    const normalizedCurrentPrice = currentPriceValue ? currentPriceValue.textContent.trim() : '';

    if (!forceUpdate && normalizedCurrentPrice === price.trim()) {
      return;
    }

    const hiddenSpan = priceEl.querySelector('.visually-hidden');
    const fromText = getFromPriceText(priceEl, price);
    priceEl.innerHTML = (hiddenSpan ? `${hiddenSpan.outerHTML} ` : '') + fromText;
    scheduleCardLayoutRefresh(layoutContainer);
  }

  function markVariablePrices(card) {
    if (card.querySelector(`${selectors.priceContent}[data-from-price]`)) return;

    const variantInputs = card.querySelectorAll(selectors.variantInput);
    if (variantInputs.length < 2) return;

    const prices = new Set();
    variantInputs.forEach(function (input) {
      const price = input.getAttribute('data-variant-price');
      if (price) {
        prices.add(price);
      }
    });

    if (prices.size > 1) {
      const priceEl = card.querySelector(selectors.priceContent);
      if (priceEl) {
        priceEl.setAttribute('data-from-price', 'true');
      }
    }
  }

  function initializeCard(card) {
    if (card.dataset.productCardInitialized === 'true') return;

    card.dataset.productCardInitialized = 'true';
    markVariablePrices(card);

    const checkedInput = card.querySelector(`${selectors.variantInput}:checked`);
    updateCardFromVariantInput(card, checkedInput, false);
    observeCardRating(card);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getRatingHeight(rating) {
    if (!rating) return 0;
    return Math.max(rating.getBoundingClientRect().height, rating.scrollHeight);
  }

  function getReservedCards(container) {
    const root = container || document;
    return [...root.querySelectorAll(`${selectors.card}${selectors.reservedCard}`)];
  }

  function getCardLayoutContainer(card) {
    if (!card) return document;
    return card.parentElement || card;
  }

  function clearEqualizedTitleSlot(card) {
    const cardText = card.querySelector(selectors.cardText);
    if (cardText) {
      cardText.style.removeProperty('--card-title-slot-height');
      cardText.style.removeProperty('--card-price-row-height');
      cardText.style.removeProperty('--card-rating-row-height');
    }
  }

  function getTitleSlotRange(cardText) {
    const styles = getComputedStyle(cardText);
    const minHeight = Number.parseFloat(styles.getPropertyValue('--card-title-slot-min-height'))
      || Number.parseFloat(styles.getPropertyValue('--card-title-slot-height'))
      || 0;
    const maxHeight = Number.parseFloat(styles.getPropertyValue('--card-title-slot-max-height'))
      || minHeight;

    return { minHeight, maxHeight };
  }

  function equalizeCardRows(container) {
    const rowCards = [];

    getReservedCards(container).forEach(function (card) {
      clearEqualizedTitleSlot(card);

      const cardText = card.querySelector(selectors.cardText);
      const title = card.querySelector(selectors.title);
      const price = card.querySelector(selectors.priceRow);
      const rating = card.querySelector(selectors.rating);

      if (!cardText || !title) return;

      const cardRect = card.getBoundingClientRect();
      const titleSlotRange = getTitleSlotRange(cardText);
      const styles = getComputedStyle(cardText);
      const priceMinHeight = Number.parseFloat(styles.getPropertyValue('--card-price-row-min-height')) || 0;
      const ratingMinHeight = Number.parseFloat(styles.getPropertyValue('--card-rating-row-min-height')) || 0;

      rowCards.push({
        cardText,
        top: Math.round(cardRect.top),
        left: Math.round(cardRect.left),
        titleHeight: title.getBoundingClientRect().height,
        priceHeight: price ? price.getBoundingClientRect().height : 0,
        ratingHeight: getRatingHeight(rating),
        minHeight: titleSlotRange.minHeight,
        maxHeight: titleSlotRange.maxHeight,
        priceMinHeight,
        ratingMinHeight,
      });
    });

    rowCards
      .sort(function (left, right) {
        if (left.top !== right.top) return left.top - right.top;
        return left.left - right.left;
      })
      .reduce(function (rows, entry) {
        const row = rows[rows.length - 1];

        if (!row || Math.abs(row.top - entry.top) > layout.rowTopTolerance) {
          rows.push({ top: entry.top, entries: [entry] });
          return rows;
        }

        row.entries.push(entry);
        return rows;
      }, [])
      .forEach(function (row) {
        const rowHeight = row.entries.reduce(function (maxHeight, entry) {
          return Math.max(maxHeight, entry.titleHeight);
        }, 0);
        const rowPriceHeight = row.entries.reduce(function (maxHeight, entry) {
          return Math.max(maxHeight, entry.priceHeight);
        }, 0);
        const rowRatingHeight = row.entries.reduce(function (maxHeight, entry) {
          return Math.max(maxHeight, entry.ratingHeight);
        }, 0);

        row.entries.forEach(function (entry) {
          const equalizedHeight = clamp(rowHeight, entry.minHeight, entry.maxHeight);
          entry.cardText.style.setProperty('--card-title-slot-height', `${equalizedHeight}px`);
          entry.cardText.style.setProperty('--card-price-row-height', `${Math.max(rowPriceHeight, entry.priceMinHeight)}px`);
          entry.cardText.style.setProperty('--card-rating-row-height', `${Math.max(rowRatingHeight, entry.ratingMinHeight)}px`);
        });
      });
  }

  function scheduleCardLayoutRefresh(container) {
    if (equalizeFrame) {
      cancelAnimationFrame(equalizeFrame);
    }

    if (equalizeTimeout) {
      clearTimeout(equalizeTimeout);
    }

    equalizeFrame = requestAnimationFrame(function () {
      equalizeFrame = 0;
      equalizeCardRows(container);
    });

    equalizeTimeout = window.setTimeout(function () {
      equalizeTimeout = 0;
      equalizeCardRows(container);
    }, 250);
  }

  function initializeCards(container) {
    const root = container || document;
    root.querySelectorAll(selectors.card).forEach(initializeCard);
    scheduleCardLayoutRefresh(root);
  }

  function observeCardRating(card) {
    const rating = card.querySelector(selectors.rating);
    if (!rating || rating.dataset.productCardRatingObserved === 'true') return;

    rating.dataset.productCardRatingObserved = 'true';

    new MutationObserver(function () {
      scheduleCardLayoutRefresh(getCardLayoutContainer(card));
    }).observe(rating, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  document.addEventListener('click', function (event) {
    const linkedVariant = event.target.closest(selectors.linkedVariant);
    if (!linkedVariant) return;

    updateCardFromLinkedVariant(linkedVariant);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches(selectors.variantInput)) return;

    const card = getCard(event.target);
    if (!card) return;

    updateCardFromVariantInput(card, event.target, true);
  });

  function observeCollectionGrid() {
    const gridContainer = document.getElementById('CollectionProductGrid');
    if (!gridContainer) return;

    new MutationObserver(function () {
      initializeCards(gridContainer);
    }).observe(gridContainer, { childList: true, subtree: true });
  }

  // Instant "<colour> · Sold out" tooltip for sold-out swatches. The swatch row
  // scrolls (overflow hidden), so a CSS tooltip would be clipped; draw one
  // fixed-position element on <body> instead. The native title attribute waits
  // about a second before showing.
  let soldOutTip = null;

  function hideSoldOutTip() {
    if (soldOutTip) soldOutTip.hidden = true;
  }

  function showSoldOutTip(item) {
    const text = item.getAttribute('data-sold-out-tooltip');
    if (!text) return;
    if (!soldOutTip) {
      soldOutTip = document.createElement('div');
      soldOutTip.className = 'product-card__sold-out-tip';
      soldOutTip.setAttribute('role', 'tooltip');
      document.body.appendChild(soldOutTip);
    }
    soldOutTip.textContent = text;
    soldOutTip.hidden = false;
    const rect = item.getBoundingClientRect();
    const tipWidth = soldOutTip.offsetWidth;
    const left = Math.min(Math.max(4, rect.left + rect.width / 2 - tipWidth / 2), document.documentElement.clientWidth - tipWidth - 4);
    soldOutTip.style.left = left + 'px';
    soldOutTip.style.top = Math.max(4, rect.top - soldOutTip.offsetHeight - 6) + 'px';
  }

  document.addEventListener('mouseover', function (event) {
    const item = event.target.closest && event.target.closest('.product-item.card .product-variant__item[data-sold-out-tooltip]');
    if (item) showSoldOutTip(item);
  });

  document.addEventListener('mouseout', function (event) {
    if (event.target.closest && event.target.closest('.product-item.card .product-variant__item[data-sold-out-tooltip]')) hideSoldOutTip();
  });

  window.addEventListener('scroll', hideSoldOutTip, { passive: true });

  window.addEventListener('resize', function () {
    scheduleCardLayoutRefresh();
  });

  window.addEventListener('load', function () {
    scheduleCardLayoutRefresh();
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scheduleCardLayoutRefresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeCards();
      observeCollectionGrid();
    });
    return;
  }

  initializeCards();
  observeCollectionGrid();
}());